import { render, staticRenderFns } from "./SkuForm.vue?vue&type=template&id=942633fa&"
import script from "./SkuForm.vue?vue&type=script&lang=js&"
export * from "./SkuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('942633fa')) {
      api.createRecord('942633fa', component.options)
    } else {
      api.reload('942633fa', component.options)
    }
    module.hot.accept("./SkuForm.vue?vue&type=template&id=942633fa&", function () {
      api.rerender('942633fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/SkuForm.vue"
export default component.exports